<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="facility">
        <div class="card-horizontal__user d-flex">
            <div class="card-horizontal__user-left" v-if="facility.user">
                <a class="card-horizontal__user-photo" :href="`/user/${facility.user_id}/profile`">
                    <img :src="`/storage${facility.user.avatar.path.replace('original', 'avatar')}`" alt="user" v-if="facility.user.avatar">
                    <span v-text="getUserPM(facility.user.name)"></span>
                </a>

            </div>
            <div class="card-horizontal__user-right">

                <div class="card-horizontal__user-name d-flex" :class="{'card-horizontal__user-name--with-descr': facility.type === 'giveaway'}">
                    <a :href="`/user/${facility.user_id}/profile`" v-if="facility.type === 'auto_help'">
                        {{facility.name || facility.user.name}}
                    </a>
                    <div v-else-if="facility.type === 'giveaway'">
                        <div v-text="facility.name"></div>
                        <a :href="`/user/${facility.user_id}/profile`">
                            {{facility.user.name}}
                        </a>
                    </div>
                    <a :href="`/user/${facility.user_id}/profile`" v-else>
                        {{facility.user.name}}{{ !facility.type ? '': `, ${facilityDictionary.type}`}}
                    </a>

                    <div class="card-horizontal__user-location" v-if="facility.city">
                        <span class="lnr lnr-map-marker"></span>{{facility.city.name}}
                    </div>


                </div>


                <div class="card-horizontal__user-descr" :style="{'-webkit-line-clamp': !openDescription ? 3 : 'unset'}" v-if="contentHeight > 66">

                    <template v-if="!openDescription">
                        <span class="card-horizontal__user-descr-content" v-html="facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='#' @click.prevent="openDescription = true" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_read_more')}}</a></span>
                    </template>
                    <template>
                        <span class="card-horizontal__user-descr-content" v-html="facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span> &nbsp;
                        <span><a href='#' @click.prevent="openDescription = false" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_collapse')}}</a></span>
                    </template>


                </div>
                <div class="card-horizontal__user-descr" v-else
                     v-html="(facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, ''))">
                </div>

                <div class="card-horizontal__user-type card-horizontal__user-type--auto-help d-flex" v-if="facility.type === 'auto_help'">{{facilityDictionary.type}}</div>
                <div class="card-horizontal__user-type card-horizontal__user-type--giveaway d-flex" v-else-if="facility.type === 'giveaway'">{{facilityDictionary.giveaway_category}}</div>

                <div class="card-horizontal__user-type card-horizontal__user-type--photo  d-flex" v-else>{{facilityDictionary.type}}</div>
                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row d-flex">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--charge"></span>
                        {{facilityDictionary.charge_category}}
                    </div>
                </div>

                <div class="card-horizontal__user-photos d-flex" v-if="facility.images.length">


                    <a class="card-horizontal__user-photos-item" :class="{'card-horizontal__user-photos-item--block': idx < 3}"
                       v-for="(image, idx) in facility.images" :href="`/storage${image.path}`"
                       :data-lightbox="'homestay-' + facility.id"
                       :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>

                    <div class="card-horizontal__user-photos-item card-horizontal__user-photos-item--block d-flex" v-if="facility.images.length > 3">
                        +{{facility.images.length - 3}}
                    </div>

                </div>

                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                    <div class="card-horizontal__user-paragraph-title">
                            <span class="lnr lnr-map-marker"></span>{{$store.getters.t('facilities_store_form_availability')}}:
                        </div>
                        {{facility.range === 'city' || facility.range === 'region' ? facilityDictionary.arr : facilityDictionary.range}}
                    </div>
                </div>

                <div class="card-horizontal__user-contact d-flex">
                    <a href="#" class="card-horizontal__user-contact-link">{{$store.getters.t('organizations_profile_pet_view')}}</a>
                    <a :href="`tel:${facility.user.public_phone}`" v-if="facility.user && facility.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">{{$store.getters.t('donors_card_call')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserDashboardFacilitiesHelps",
    props: ['facility', 'index'],
    data(){
        return{
            contentHeight: 0,
            media: null,
            openDescription: false,
        }
    },

    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },

    mounted(){
        this.getContent(this.index)
    },

    watch:{
        media() {
            this.getContent(this.index)
        },
    },

            computed: {

        facilityDictionary(){

            let object = (({type, range, charge_category,cities,regions, giveaway_category = null}) =>
                ({type, range, charge_category,arr:[...cities,...regions], giveaway_category}))(this.facility)


            if(object.type === 'giveaway'){
                switch(object.giveaway_category){
                    case 'medical':
                        object.giveaway_category = this.$store.getters.t('facilities_store_form_medical')
                        break;
                    case 'nutrition':
                        object.giveaway_category = this.$store.getters.t('facilities_store_form_nutrition')
                        break;
                    case 'other':
                        object.giveaway_category = this.$store.getters.t('facilities_store_form_other')
                        break;
                    default:
                        object.giveaway_category = ''
                }

            }

            switch (object.type){
                case 'photo_help':
                    object.type = this.$store.getters.t('facilities_store_form_photo_help')
                    break;
                case 'pr_help':
                    object.type = this.$store.getters.t('facilities_store_form_pr')
                    break;
                case 'auto_help':
                    object.type = this.$store.getters.t('facilities_store_form_auto_help')
                    break;
                case 'giveaway':
                    object.type = this.$store.getters.t('facilities_store_form_giveaway')
                    break;
                default:
                    object.type = ''
            }



            switch (object.range){
                case 'city':
                case 'region':
                    object.arr = object.arr.map(item => item.name).join(', ')
                    break;
                case 'country':
                    object.range = this.$store.getters.t('facilities_card_range_country')
                    break;
                case 'abroads':
                    object.range = this.$store.getters.t('facilities_card_range_abroads')
                    break;
                default:
                    object.range = ''
            }

            switch (object.charge_category){
                case 'free':
                    object.charge_category = this.$store.getters.t('facilities_store_form_free')
                    break;
                case 'paid_for':
                    object.charge_category = this.$store.getters.t('facilities_store_form_paid')
                    break;
                case 'cost_recovery':
                    object.charge_category = this.$store.getters.t('facilities_store_form_cost_recovery')
                    break;
                default:
                    object.charge_category = ''
            }



            return object

        },
    },

    methods:{

        myEventHandler(e){
            this.media = window.innerWidth
        },

        getContent(index){

            if(typeof index !== 'number') return this.contentHeight = 0

            let descr = document.querySelector(`.card-horizontal__${index} .card-horizontal__user-descr`).scrollHeight

            this.contentHeight = descr
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }
}
</script>

<style scoped>

</style>
